<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="list-btn">
			<RadioGroup v-model="animal">
				<Radio label="列表"></Radio>
				<Radio label="地图"></Radio>
			</RadioGroup>
		</div>
		<div  class="lb" v-if="animal=='列表'">
			<Table border :columns="columns12" :data="data6" :loading="loading">
				<template slot-scope="{ row }" slot="name">
					<strong>{{ row.name }}</strong>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					
					
				</template>
			</Table>
			<div class="my-page">
				<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		<div class="ditu" v-else>
			<ditu :zxd="zxd" :qt="qt" ></ditu>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import ditu from '@/components/comm/ditu/ditu.vue'
	export default {
		data() {
			return {
				animal: '列表',
				//地图
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					/* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
				],
				//地图
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '设备编号',
						key: 'macCode'
					},
					{
						title: '出货口数量',
						key: 'holeType',
						render: (h, params) => {
							return h("div",params.row.holeType+'个')
						}
					},
					{
						title: '出货口1标识',
						key: 'uuid1'
					},
					{
						title: '出货口2标识',
						key: 'uuid2'
					},
					{
						title: '位置',
						key: 'address'
					},
					{
						title: '经纬度',
						key: 'unitPrice',
						render: (h, params) => {
							if(params.row.longitude==null || params.row.longitude==''){
								return h("div","暂无")
							}else{
								return h("div",params.row.longitude+","+params.row.latitude)
							}
						}
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10,
					orderId:'',
					macDetailsId:''
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/orderId',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macLeaveFactorys.totalElements
						_this.data6 = data.macLeaveFactorys.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			ajaxPageDitu() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/orderId',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let a = data.macLeaveFactorys.content
						console.log(a)
						for (var i = 0; i < a.length; i++) {
							let latitude = parseFloat(a[i].latitude)
							let longitude = parseFloat(a[i].longitude)
							let b = {
								position: [longitude, latitude],
								id: a[i].id,
								url: '',
								address: a[i].address,
								code: a[i].macCode,
							}
						
							_this.qt.push(b)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page,ditu
	    },
		created(){
			let orderId=this.$route.query.orderId;
			let macDetailsId=this.$route.query.macDetailsId;
			
			this.query.orderId=orderId
			this.query.macDetailsId=macDetailsId
			this.ajaxPage()
			this.ajaxPageDitu()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/facility/macOrder/mac/list.vue